import React from 'react';
import { ArrowUp, Heart } from 'lucide-react';
import { getBrandFromVendor, isBrandActive } from '../../utils/vendorBranding';

const VendorHeaderInfo = ({
  vendor,
  brand: brandProp,
  isFavorited,
  onToggleFavorite,
  onShare,
  isLoading = false,
  isAuthenticated = false,
  hideTitle = false,
}) => {
  const brand = brandProp || getBrandFromVendor(vendor);
  const active = isBrandActive(brand);
  const showLogo = active && brand.show_logo_in_header !== false && brand.logo_url;
  const bannerMode = active && brand.hero_style === 'banner';

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex items-start justify-between gap-4">
        {!hideTitle && (
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2.5 sm:gap-3">
              {!bannerMode && showLogo && (
                <img
                  src={brand.logo_url}
                  alt=""
                  className="h-9 w-9 shrink-0 rounded-lg border border-m-border-light object-cover sm:h-10 sm:w-10"
                />
              )}
              <div className="min-w-0">
                {!bannerMode && (
                  <h1 className="marketing-display-md break-words text-m-ink">
                    {vendor?.business_name}
                  </h1>
                )}
                {brand?.tagline && !bannerMode && (
                  <p className="marketing-body mt-1 text-m-ink-muted">
                    {brand.tagline}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        <div className={`flex shrink-0 gap-4 sm:gap-6 ${hideTitle ? 'ml-auto' : ''}`}>
          <button
            type="button"
            onClick={onShare}
            className="flex items-center gap-1.5 text-sm font-medium text-m-ink transition-opacity hover:opacity-70 touch-manipulation sm:gap-2 sm:text-base"
            aria-label="Share vendor"
          >
            <ArrowUp className="h-4 w-4 sm:h-5 sm:w-5" />
            <span className="underline underline-offset-2">Share</span>
          </button>
          {isAuthenticated && (
            <button
              type="button"
              onClick={onToggleFavorite}
              disabled={isLoading}
              className="flex items-center gap-1.5 text-sm font-medium text-m-ink transition-opacity hover:opacity-70 touch-manipulation disabled:cursor-not-allowed disabled:opacity-50 sm:gap-2 sm:text-base"
              aria-label={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
            >
              <Heart
                className={`h-4 w-4 transition-all sm:h-5 sm:w-5 ${
                  isFavorited ? 'fill-current text-m-ink' : ''
                } ${isLoading ? 'animate-pulse' : ''}`}
              />
              <span className="underline underline-offset-2">
                {isLoading ? 'Saving…' : 'Save'}
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorHeaderInfo;
